// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select:not(.is-multiple):not(.is-loading)::after {\n  margin-right: 92%;\n}\n.select select:not([multiple]) {\n  padding-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
